import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../middleware/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const getUser = useCallback(async () => {
        if (localStorage.getItem('token')) {
            try {
                const response = await api.get('/users');
                if (response.data) {
                    setUser(response.data);
                }
            } catch (error) {
                console.error('Failed to fetch user:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getUser();
    }, [getUser]);

    const login = useCallback(async (credentials) => {
        try {
            const response = await api.post('/auth/login', credentials);
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
                await getUser();
            }
        } catch (error) {
            console.error('Login failed:', error);
        }
    }, [getUser]);

    const logout = useCallback(() => {
        localStorage.removeItem('token');
        setUser(null);

    }, []);

    const isAuthenticated = !!user;

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout, isAuthenticated, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
